import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { CreateCommentPayload, TimelineComment } from '../types';

type CreateCommentVariables = {
    orgId: string;
    dealId: number;
    timelineId: number;
    payload: CreateCommentPayload;
};

export const createComment = async ({
    orgId, dealId, timelineId, payload,
}: CreateCommentVariables): Promise<TimelineComment> => {
    const response = await axiosInstance.post<TimelineComment>(
        API_ENDPOINTS.TIMELINE_COMMENTS(orgId, dealId, timelineId),
        payload,
    );
    return response.data;
};

export const useCreateComment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createComment,
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.TIMELINE_COMMENTS, variables.orgId, variables.dealId, variables.timelineId],
            });
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.TIMELINE_LATEST_COMMENTS, variables.orgId, variables.dealId],
            });
        },
    });
};
